import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconDropdownArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#E0E0E0",
		d: "M8.5 16.586c0 .89 1.077 1.337 1.707.707l4.586-4.586c.39-.39.39-1.024 0-1.414l-4.586-4.586c-.63-.63-1.707-.184-1.707.707v9.172z"
	})
});
export default SvgIconDropdownArrowRight;
